import { QuestionnaireAnswerType } from 'components/Assessments/types'
import { PatientOverviewQuestionnaireItem } from './questionnaire'

// Patient overview questionnaire answer type mapping
export const PATIENT_OVERVIEW_QUESTIONNAIRE_ITEM_TO_ANSWER_TYPE = {
  // Demographics
  [PatientOverviewQuestionnaireItem.PATIENT_OVERVIEW_DEMOGRAPHICS_LEGAL_NAME]:
    QuestionnaireAnswerType.STRING,
  [PatientOverviewQuestionnaireItem.PATIENT_OVERVIEW_DEMOGRAPHICS_PREFERRED_NAME]:
    QuestionnaireAnswerType.STRING,
  [PatientOverviewQuestionnaireItem.PATIENT_OVERVIEW_DEMOGRAPHICS_DATE_OF_BIRTH]:
    QuestionnaireAnswerType.STRING,
  [PatientOverviewQuestionnaireItem.PATIENT_OVERVIEW_DEMOGRAPHICS_ADDRESS]:
    QuestionnaireAnswerType.STRING,
  [PatientOverviewQuestionnaireItem.PATIENT_OVERVIEW_DEMOGRAPHICS_GENDER]:
    QuestionnaireAnswerType.STRING,
  [PatientOverviewQuestionnaireItem.PATIENT_OVERVIEW_DEMOGRAPHICS_SEX]:
    QuestionnaireAnswerType.STRING,
  [PatientOverviewQuestionnaireItem.PATIENT_OVERVIEW_DEMOGRAPHICS_MEDICAID_ID]:
    QuestionnaireAnswerType.STRING,
  [PatientOverviewQuestionnaireItem.PATIENT_OVERVIEW_DEMOGRAPHICS_SSN]:
    QuestionnaireAnswerType.STRING,
  [PatientOverviewQuestionnaireItem.PATIENT_OVERVIEW_DEMOGRAPHICS_PRIMARY_LANGUAGE]:
    QuestionnaireAnswerType.STRING,
  [PatientOverviewQuestionnaireItem.PATIENT_OVERVIEW_DEMOGRAPHICS_RELIGION]:
    QuestionnaireAnswerType.STRING,
  [PatientOverviewQuestionnaireItem.PATIENT_OVERVIEW_DEMOGRAPHICS_RACE]:
    QuestionnaireAnswerType.STRING,

  // Care Team
  [PatientOverviewQuestionnaireItem.PATIENT_OVERVIEW_CARE_TEAM_LEGAL_GUARDIAN_NAME]:
    QuestionnaireAnswerType.STRING,
  [PatientOverviewQuestionnaireItem.PATIENT_OVERVIEW_CARE_TEAM_LEGAL_GUARDIAN_RELATION_TO_PATIENT]:
    QuestionnaireAnswerType.STRING,
  [PatientOverviewQuestionnaireItem.PATIENT_OVERVIEW_CARE_TEAM_CAREGIVER_NAME]:
    QuestionnaireAnswerType.STRING,
  [PatientOverviewQuestionnaireItem.PATIENT_OVERVIEW_CARE_TEAM_CAREGIVER_RELATION_TO_PATIENT]:
    QuestionnaireAnswerType.STRING,
  [PatientOverviewQuestionnaireItem.PATIENT_OVERVIEW_CARE_TEAM_ORDERING_PRACTITIONER]:
    QuestionnaireAnswerType.STRING,
  [PatientOverviewQuestionnaireItem.PATIENT_OVERVIEW_CARE_TEAM_PRIMARY_CARE_PROVIDER]:
    QuestionnaireAnswerType.STRING,
  [PatientOverviewQuestionnaireItem.PATIENT_OVERVIEW_CARE_TEAM_ORDER_PREFERENCE]:
    QuestionnaireAnswerType.STRING,
  [PatientOverviewQuestionnaireItem.PATIENT_OVERVIEW_CARE_TEAM_SOC_DATE]:
    QuestionnaireAnswerType.DATE_TIME,
  [PatientOverviewQuestionnaireItem.PATIENT_OVERVIEW_CARE_TEAM_F2F_DATE]:
    QuestionnaireAnswerType.DATE,
  [PatientOverviewQuestionnaireItem.PATIENT_OVERVIEW_CARE_TEAM_EMERGENCY_CONTACT_NAME]:
    QuestionnaireAnswerType.STRING,
  [PatientOverviewQuestionnaireItem.PATIENT_OVERVIEW_CARE_TEAM_EMERGENCY_CONTACT_PHONE]:
    QuestionnaireAnswerType.STRING,
  [PatientOverviewQuestionnaireItem.PATIENT_OVERVIEW_CARE_TEAM_EMERGENCY_CONTACT_ADDRESS]:
    QuestionnaireAnswerType.STRING,
  [PatientOverviewQuestionnaireItem.PATIENT_OVERVIEW_CARE_TEAM_ALTERNATE_CAREGIVER_NAME]:
    QuestionnaireAnswerType.STRING,
  [PatientOverviewQuestionnaireItem.PATIENT_OVERVIEW_CARE_TEAM_ALTERNATE_CAREGIVER_PHONE]:
    QuestionnaireAnswerType.STRING,
  [PatientOverviewQuestionnaireItem.PATIENT_OVERVIEW_CARE_TEAM_ALTERNATE_CAREGIVER_ADDRESS]:
    QuestionnaireAnswerType.STRING
}
